{
  "actions": "कार्रवाइयां",
  "activeStakes": "सक्रिय स्टेक्स",
  "apy": "APY",
  "claimNow": "अभी क्लेम करें",
  "claimRewards": "रिवॉर्ड प्राप्त करें",
  "claimRewardsFailed": "रिवॉर्ड प्राप्त करने में असफल।",
  "days": "दिन",
  "duration": "समय",
  "enterExaltAmount": "EXALT राशि दर्ज करें",
  "enterStakeAmount": "स्टेक करने के लिए राशि दर्ज करें",
  "enterValidExaltAmount": "कृपया सही EXALT राशि दर्ज करें।",
  "enterValidStakeAmount": "कृपया मान्य स्टेक राशि दर्ज करें।",
  "estimatedApr": "अनुमानित APR",
  "estimatedRewards": "अनुमानित रिवॉर्ड्स",
  "exaltStaking": "EXALT स्टेकिंग",
  "insufficientBalance": "अपर्याप्त EXALT बैलेंस।",
  "loading": "लोड हो रहा है...",
  "lockPeriod": "लॉक अवधि",
  "minimumStake": "न्यूनतम स्टेक",
  "nextReward": "अगला रिवॉर्ड",
  "noActiveStakesYet": "अभी कोई सक्रिय स्टेक नहीं है",
  "noRewardHistory": "कोई रिवॉर्ड इतिहास उपलब्ध नहीं।",
  "pendingReward": "लंबित रिवॉर्ड",
  "processing": "प्रोसेसिंग...",
  "rewardHistory": "रिवॉर्ड इतिहास",
  "rewardRate": "रिवॉर्ड दर",
  "rewardsClaimedSuccessfully": "रिवॉर्ड सफलतापूर्वक प्राप्त हो गया।",
  "rewardsEarned": "अर्जित इनाम",
  "securityNotice": "सुरक्षा सूचना",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "stake": "स्टेक",
  "stakeCompleted": "पूर्ण",
  "stakeExalt": "EXALT स्टेक करें",
  "stakeHistory": "स्टेक इतिहास",
  "stakeNow": "अभी स्टेक करें",
  "stakingFailed": "स्टेकिंग असफल रही।",
  "stakingSecurity1": "बैकएंड सत्यापन के बाद रिवॉर्ड जमा किए जाते हैं।",
  "stakingSecurity2": "जल्दी अनस्टेक करने के नियम लागू हो सकते हैं।",
  "stakingSecurity3": "असाधारण मामलों में मालिक/एडमिन की मंजूरी आवश्यक हो सकती है।",
  "stakingSecurity4": "प्रोसेसिंग से पहले ब्लॉकचेन पुष्टिकरण सत्यापित किए जाते हैं।",
  "stakingStartedSuccessfully": "स्टेकिंग सफलतापूर्वक शुरू हो गई।",
  "stakingSubtitle": "EXALT स्टेक करें और नियमित रिवॉर्ड कमाएँ",
  "stakingTitle": "EXALT स्टेकिंग",
  "totalRewards": "कुल रिवॉर्ड",
  "totalStaked": "कुल स्टेक किया गया",
  "unavailable": "अनुपलब्ध",
  "unstake": "अनस्टेक करें",
  "unstakeFailed": "अनस्टेक असफल रहा।",
  "unstakeNow": "अभी अनस्टेक करें",
  "unstakedSuccessfully": "अनस्टेक सफलतापूर्वक हो गया।"
}